module.exports = __webpack_public_path__ + "static/img/zhyy-banner.f438886.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/zhyy-banner.jpg
// module id = VY4Y
// module chunks = 1